import './MaturityScoreBar.css';

export interface MaturityScoreBarProps {
  capabilityName: string;
  score: number;
  maxScore?: number;
}

export function MaturityScoreBar({
  capabilityName,
  score,
  maxScore = 6,
}: MaturityScoreBarProps): JSX.Element {
  const percentage = Math.round((score / maxScore) * 100);

  return (
    <div className="maturity-score-bar">
      <div className="maturity-score-bar__label">
        <span className="maturity-score-bar__name">{capabilityName}</span>
        <span className="maturity-score-bar__value">
          {score.toFixed(1)} / {maxScore}
        </span>
      </div>
      <div
        className="maturity-score-bar__track"
        role="progressbar"
        aria-valuenow={score}
        aria-valuemin={1}
        aria-valuemax={maxScore}
        aria-label={`${capabilityName}: ${score} out of ${maxScore}`}
      >
        <div
          className="maturity-score-bar__fill"
          style={{ width: `${percentage}%` }}
          data-level={Math.round(score)}
        />
      </div>
    </div>
  );
}
